import { useTranslation } from 'react-i18next';
import { PagePath } from '@monorepo/client-types';
import { Stack, Tooltip, TooltipPlacement } from '@monorepo/nova-ui';
import { CartData } from '@monorepo/types';
import { useConditionalLink } from '../../../hooks';
import { useNewOrderButtonState } from './hooks';
import {
  StyledNewOrderButton,
  StyledNewOrderButtonIcon,
  StyledNewOrderButtonText,
} from './styles/new-order-button.styled';

interface NewOrderButtonProps {
  cartData?: CartData;
}

export const NewOrderButton = ({ cartData }: NewOrderButtonProps) => {
  const Link = useConditionalLink();
  const { t } = useTranslation('hubCommon');
  const { paymentsEnabled, handleClick } = useNewOrderButtonState({ cartData });

  const Content = (
    <Stack
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      <StyledNewOrderButtonText>{t('newOrder')}</StyledNewOrderButtonText>
      <StyledNewOrderButtonIcon iconName="CaretRight" />
    </Stack>
  );

  return (
    <StyledNewOrderButton
      aria-label={t('newOrder')}
      disabled={!paymentsEnabled}
      id="new-order-button"
      data-testid="new-order-button"
      onClick={paymentsEnabled ? handleClick : undefined}
    >
      {!paymentsEnabled ? (
        <Tooltip
          title={t('paymentsDisabled')}
          placement={TooltipPlacement.Bottom}
        >
          <span style={{ display: 'inline-flex' }}>{Content}</span>
        </Tooltip>
      ) : (
        <Link href={PagePath.Purchase}>{Content}</Link>
      )}
    </StyledNewOrderButton>
  );
};
